import { Button } from '../ui/button'

const MainErrorFallback = () => {
  return (
    <div className="h-dvh flex flex-col items-center justify-center">
      <h2>Ooops, something went wrong :( </h2>
      <Button className="mt-4" onClick={() => window.location.assign(window.location.origin)}>
        Refresh
      </Button>
    </div>
  )
}

export { MainErrorFallback }
